module.exports = __webpack_public_path__ + "media/assets/images/protocols-684e195d607413f925c414cf783f214c.svg";